import styled from 'styled-components';

export const ExpandedMobileItem = styled.div`
  display: table-row;
`;
